export interface ColumnModel {
    name: string;
    label: string;
    isSortDesc?: boolean;
    isSortable?: boolean;
    class?: string;
    type: string;
    sortColumnName?: string;
}